@for (el of path; track i; let i = $index) {
  <a class="link pointer" (click)="brearCrumbNavigate(el)">{{el.name | translate}}</a>
  @if (i !== path.length - 1) {
    <p class="crumb-separator"> > </p>
  }
}
